export default class SubscriberFormSettingsCtrl {
    constructor($scope, $filter, $stateParams, $state, SideMenu, SubscriberForm, Events) {
        SideMenu.setActive('subscriber');

        this._stateParams = $stateParams;
        this._translator = $filter('translate');
        this._state = $state;
        this._scope = $scope;
        
        this.subscriberFormRepo = SubscriberForm;
        this.eventHandler = Events;

        this.status = 'settings';
        this.subscriberForm = {
            settings: {
                data: {
                    success_url: null,
                    confirmation_success_url: null,
                    error_url: null
                }
            }
        };

        this.subscriberFormRepo.find(this._stateParams.id, [ 'settings', 'email' ]).then((subscriberForm) => {
            this.subscriberForm = subscriberForm.data;
        });

        this._scope.$on('subscriberForm:goTo', (event, toState) => {
            return this.goTo(toState);
        });

        this._scope.$on('account:changed', () => {
            this._state.go('subscriberForm.index');
        });
    }

    goTo(page) {
        switch (page) {
            case 'email':
                if (this.subscriberForm.email) {
                    this._state.go('subscriberForm.email.edit', {
                        id: this._stateParams.id,
                        emailId: this.subscriberForm.email.id
                    });
                } else {
                    this._state.go('subscriberForm.email', { id: this._stateParams.id });
                }
                
                break;
            case 'builder':
                this._state.go('subscriberForm.edit', { id: this._stateParams.id });
                break;
            default:
                this._state.go('subscriberForm.' + page, { id: this._stateParams.id });
        }
    };

    validSettings() {
        let settings = this.subscriberForm.settings;

        return (settings.success_url || settings.confirmation_success_url || settings.error_url);
    };

    updateSettings() {
        if (! this.validSettings()) {
            return;
        }

        this.subscriberFormRepo.addSettings(this.subscriberForm.id, this.subscriberForm.settings).then(() => {
            this.eventHandler.flashEvent('notification', this._translator('GLOBAL:UPDATED'));
        }, (error) => {
            if (error.status === 400) {
                if (error.data.code == 11) {
                    this.eventHandler.flashEvent('error', this._translator('SUBSCRIBER:SUBSCRIBER_FORM:INVALID_URL'));
                }
            }
        });
    };
};
